export default __webpack_public_path__ + "static/media/movrec.2fc6f9b0.png";